/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ticketpageholder2Inputs */

const en_ticketpageholder2 = /** @type {(inputs: Ticketpageholder2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For ${i?.name}`)
};

const de_ticketpageholder2 = /** @type {(inputs: Ticketpageholder2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auf ${i?.name}`)
};

/**
* | output |
* | --- |
* | "For {name}" |
*
* @param {Ticketpageholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageholder2 = /** @type {((inputs: Ticketpageholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageholder2(inputs)
	return de_ticketpageholder2(inputs)
});
export { ticketpageholder2 as "ticketPageHolder" }